function validation(paint) {
    let errors = {}

    // title
    if (!paint.title) {
        errors.title = 'تیتر را وارد نکردید.'
    } else if (!paint.title.trim()) {
        errors.title = 'تیتر را وارد نکردید.'
    } else if (paint.title.length > 200) {
        errors.title = 'طول تیتر نباید بیشتر از 200 کارکتر باشد.'
    } else {
        delete errors.title
    }
    // image
    if (!paint.images.length) {
        errors.images = 'لطفا عکس گوشه را وارد کنید.'
    } else {
        delete errors.images
    }
    // body
    if (paint.body.length < 200) {
        errors.body = "طول توضیحات باید بیش از 200 کارکتر باشد"
    } else {
        delete errors.body
    }

    return errors
}
export default validation;